/** @jsxImportSource react */

export function Resultados2023View() {
  return (
    <div
      className="flex h-full flex-col"
      style={{ backgroundColor: "#F4F8FB" }}
    >
      {/* Main content area - grows to fill space */}
      <div className="flex min-h-0 flex-1 gap-4 p-4">
        {/* Column 1 */}
        <div className="flex w-1/3 flex-col rounded-lg border border-slate-200 bg-white">
          {/* Panel Header */}
          <div
            className="shrink-0 border-b border-slate-200 px-4 py-3"
            style={{ backgroundColor: "#E5EDF3" }}
          >
            <h2 className="text-lg font-semibold text-slate-800">
              Resultados por provincia
            </h2>
          </div>

          {/* Panel Content - takes all available height */}
          <div className="flex min-h-0 min-w-0 flex-1 flex-col items-stretch justify-stretch">
            <iframe
              src="https://flo.uri.sh/visualisation/25848947/embed"
              title="Interactive or visual content"
              className="h-full w-full border-0"
              scrolling="no"
              sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
            />
          </div>
        </div>

        {/* Column 2 */}
        <div className="flex w-1/3 flex-col rounded-lg border border-slate-200 bg-white">
          {/* Panel Header */}
          <div
            className="shrink-0 border-b border-slate-200 px-4 py-3"
            style={{ backgroundColor: "#E5EDF3" }}
          >
            <h2 className="text-lg font-semibold text-slate-800">
              Mapa de Resultados
            </h2>
          </div>

          {/* Panel Content - takes all available height */}
          <div className="flex min-h-0 min-w-0 flex-1 flex-col items-stretch justify-stretch">
            <iframe
              src="https://flo.uri.sh/visualisation/25856760/embed"
              title="Interactive or visual content"
              className="h-full w-full border-0"
              scrolling="no"
              sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
            />
          </div>
        </div>

        {/* Column 3 */}
        <div className="flex w-1/3 flex-col rounded-lg border border-slate-200 bg-white">
          {/* Panel Header */}
          <div
            className="shrink-0 border-b border-slate-200 px-4 py-3"
            style={{ backgroundColor: "#E5EDF3" }}
          >
            <h2 className="text-lg font-semibold text-slate-800">
              
            </h2>
          </div>

          {/* Panel Content with scroll */}
          <div className="flex min-h-0 min-w-0 flex-1 flex-col items-stretch justify-stretch overflow-y-auto p-4">
            {/* Placeholder */}
            <div className="flex h-full items-center justify-center">
              <div className="text-center">
                <div className="mb-4 text-6xl">📊</div>
                <h3 className="mb-2 text-xl font-semibold text-slate-700">
                  Próximamente
                </h3>
                <p className="text-slate-500">Tercera visualización</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
